module.exports = __webpack_public_path__ + "img/Onda_fundo_azul.bd9cc381.png";